export enum AuthChannel {
  Text,
  Voice,
  Email,
}
